// 1. Misyonumuz.jsx
import React from "react";
import HeroSlider from "../components/HeroSlider";
import Footer from "../components/Footer";
import CorporateSidebar from "../components/Corporate/CorporateSidebar";

const CorporateMission = () => {
  return (
    <div>
      <HeroSlider />
      <div className="bg-white text-black py-8 px-4 max-w-screen-xl mx-auto">
        {/* <div className="text-sm text-gray-600 mb-4">
          <span className="underline">ana sayfa</span> &nbsp;>&nbsp;
          <span className="underline">kurumsal</span> &nbsp;>&nbsp;
          <span>misyonumuz</span>
        </div> */}

        <div className="text-xl font-semibold text-[#003132] mb-6">KURUMSAL MENÜ</div>

        <div className="flex flex-col md:flex-row gap-10">
          <CorporateSidebar />
          <div className="flex-1">
            <h2 className="text-2xl font-bold mb-4 text-[#003132]">Misyonumuz</h2>
            <p className="text-gray-800 leading-relaxed">
             Abone Halı Yıkama olarak misyonumuz, tüm temizlik süreçlerinde insan sağlığına duyarlı, 
              teknolojik ve etkili çözümler sunarak müşterilerimize en üygün hizmeti vermektir. 
              Profesyonel kadromuzla, hijyen standartlarından ödün vermeden hizmet sunmak temel ilkemizdir.
            </p>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default CorporateMission
